import { Component, OnInit, ViewChild } from '@angular/core';

import { Router } from '@angular/router';
import { AppInformationService, ArkUnitOfWork, AuthService, UtilityService } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { EntityQuery } from 'breeze-client';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BatchEditDialogComponent } from '../batch-edit-dialog/batch-edit-dialog.component';

@Component({
    selector: 'app-classis-list',
    templateUrl: './classis-list.component.html',
    styleUrls: ['./classis-list.component.scss'],
    imports: [DevExtremeModule],
    standalone: true,
})
export class ClassisListComponent implements OnInit {
    classisBatches: any[] = [];
    classisByBatches: any[] = [];
    startDate: Date;
    endDate: Date;
    userAccess = false;
    reviewOnly = true;
    graafschap = false;
    statuses: any[];
    selectedStatus: any;
    selectedBatchIds: number[] = [];
    completeDisabled = true;

    onToolbarPreparing = SharedModule.onToolbarPreparing;
    @ViewChild('classisGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private router: Router,
        private auth: AuthService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        this.graafschap = this.appInfo.settings.church === 'graafschap';
        this.reviewOnly = this.auth.hasRole('Secretary');
        this.userAccess = true;
        this.statuses = await this.uow.contributionBatchStatuses.all();
        this.selectedStatus = 2;
        // this.startDate = moment(new Date()).startOf('month').toDate();
        // this.endDate = new Date();
        this.getData();
    }

    async getData() {
        const batches = await this.uow.getClassisList(
            this.startDate ? this.startDate : new Date('1/1/2019'),
            this.endDate ? this.endDate : new Date('1/1/2099'),
            this.selectedStatus
        );
        this.classisBatches = (batches as any[]).map((item, idx) => ({ ...item, dxKey: idx }));

        const byBatches = await this.uow.getClassisListByBatches(
            this.startDate ? this.startDate : new Date('1/1/2019'),
            this.endDate ? this.endDate : new Date('1/1/2099'),
            this.selectedStatus
        );
        this.classisByBatches = (byBatches as any[]).map((item, idx) => ({ ...item, dxKey: idx }));
    }

    async printReport() {
        const start = this.startDate ? this.startDate : new Date('1/1/2019');
        const end = this.endDate ? this.endDate : new Date('1/1/2099');

        const result = await this.utility.monthEndReport(start, end, this.selectedStatus);
    }

    // onToolbarPreparing(e) {
    //     e.toolbarOptions.items.unshift({
    //         location: 'before',
    //         template: 'toolbarButtons'
    //     });
    // }

    add() {
        const modalRef = this.modalService.show(BatchEditDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: { routerOption: 'new' }
        });

        modalRef.content.result.subscribe(async result => {
            if (result.result) {
                // this.batches = await this.uow.getBatchList();
                this.open(result.batchId);
                this.dataGrid.instance.refresh();
            }
        });
    }

    async open(batchId: number, newBatch?: boolean) {
        if (batchId || newBatch) this.router.navigate(['/giving/batches/' + (batchId ? batchId : 'new')]);
        // const modalRef = this.modalService.show(BatchEditDialogComponent, {
        //     class: 'modal-md',
        //     ignoreBackdropClick: true,
        //     keyboard: false,
        //     initialState: { batchId }
        // });

        // modalRef.content.result.subscribe(async result => {
        //     if (result) {
        //         // this.batches = await this.uow.getBatchList();
        //         this.dataGrid.instance.refresh();
        //     }
        // });
    }

    calculateSelectedRow(options) {
        if (options.name === 'SelectedRowsSummary') {
            if (options.summaryProcess === 'start') {
                options.totalValue = 0;
            } else if (options.summaryProcess === 'calculate') {
                if (options.component.isRowSelected(options.value.id)) {
                    options.totalValue = options.totalValue + options.value.total;
                }
            }
        }
    }
    onSelectionChanged(e) {
        const selectedBatches = e.rows[e.newRowIndex].data.idList;
        // console.log(selectedBatches);

        this.selectedBatchIds.length = 0;
        selectedBatches.forEach(batchId => {
            this.selectedBatchIds.push(batchId.batchId);
        });
        if (this.selectedBatchIds.length > 0) this.completeDisabled = false;
        // console.log('selectedIdAsNumber?',this.selectedBatchIds);
    }

    async markAsComplete() {
        if (!!this.selectedBatchIds) {
            const dialogResult = await (<Promise<boolean>>confirm('Are you sure you want to mark the selected batch as COMPLETE?', 'Graafschap CRC'));
            if (!dialogResult) return;
            else {
                console.log('selectedIds', this.selectedBatchIds);
                const query = EntityQuery.from('ContributionBatches').where('id', 'in', this.selectedBatchIds);
                const data = await this.uow.manager.executeQuery(query);
                const batches = data.results as any;

                batches.forEach(batch => {
                    batch.statusId = 3;
                });
                // });
                await this.uow.commit();
                await this.getData();
            }
        }
    }
}
